import React from 'react'
import {getComponentDisplayName} from '@modifi/utilities'
import type {BasePathCtx} from './context'
import useBasePath from './useBasePath'
import usePrependBasePath from './usePrependBasePath'

type InjectedProps = {
  basePath?: BasePathCtx['basePath'] | null
  prependBasePath?: BasePathCtx['prependBasePath'] | null
}

const withBasePath = <P extends {}, T>(
  WrappedComponent: React.ComponentType<P & InjectedProps>
): React.ComponentType<React.PropsWithRef<React.PropsWithoutRef<P> & React.RefAttributes<T>>> => {
  const ScopedComponent = React.forwardRef<T, P>((props, ref) => {
    const basePath = useBasePath()
    const prependBasePath = usePrependBasePath()

    return (
      <WrappedComponent
        {...props}
        basePath={basePath}
        prependBasePath={prependBasePath}
        ref={ref}
      />
    )
  })

  ScopedComponent.displayName = `withBasePath(${getComponentDisplayName(WrappedComponent)})`

  return React.memo(ScopedComponent)
}

export default withBasePath
